angular.module('leanlaw').controller('MyReceivablesReportSidebarCtrl', ['$scope', '$rootScope', 'userService', function ($scope, $rootScope, userService) {
  $scope.filter = {
    include: {}
  };
  $scope.filter.include.matters = false;
  activate();
  async function activate() {
    const me = await userService.me();
    $scope.me = me;
    $scope.accounts = await userService.list();
    $scope.accounts = $scope.accounts.filter(a => a.id === me.id);
    $scope.filter.selectedUser = $scope.accounts[0];
    $scope.scopeString = "primary";
    $scope.filter.primary = true;
    $scope.archiveOptions = [{
      label: "Exclude Archived",
      status: "active"
    }, {
      label: "Include Archived",
      status: "all"
    }, {
      label: "Only Archived",
      status: "archived"
    }];
    $scope.customFilter = {
      // account: $scope.accounts[0],
      scopeAccount: $scope.accounts[0],
      archived: $scope.archiveOptions[1],
      filter: {
        primary: true,
        originating: false,
        reviewer: false,
        data: "receivables,aging",
        zeros: false,
        scope: "primary",
        scopeAccount: $scope.accounts[0]
      }
    };
    $scope.archivedChange = function (archived) {
      $scope.customFilter.archived = archived;
      $scope.customFilter.status = archived.status;
    };
    $scope.$watch("customFilter", () => {
      $scope.customFilter.filter.scope = $scope.scopeString;
      $rootScope.$broadcast("report-sidebar-custom-filter-change", $scope.customFilter);
    }, true);
    $scope.$watch("filter", () => {
      $rootScope.$broadcast("report-sidebar-filterchange", $scope.filter);
    }, true);
  }
  $scope.updateScopeString = function (value, isChecked) {
    if (value === 'primary') {
      $scope.filter.primary = isChecked;
    } else if (value === 'reviewer') {
      $scope.filter.reviewer = isChecked;
    } else if (value === 'originating') {
      $scope.filter.originating = isChecked;
    }
    $scope.scopeString = scopeFromFilter($scope.filter);
  };
  function scopeFromFilter(filter) {
    const {
      primary,
      reviewer,
      originating
    } = filter;
    const scopes = [];
    if (primary) scopes.push('primary');
    if (reviewer) scopes.push('reviewer');
    if (originating) scopes.push('originating');
    return scopes.length ? scopes.join(',') : 'involved';
  }
}]);